// src/pages/manager/ContinentalDiscountManager.jsx
import React from 'react';
import OrderDiscountManager from '../DiscountComplimentaryManager';

const ContinentalDiscountManager = () => {
  return <OrderDiscountManager locationKey="continental" />;
};

export default ContinentalDiscountManager;